import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useWishlist } from "../context/WishlistContext";
import "./Header.css";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const { wishlistCount } = useWishlist();

  const isActive = (path) => {
    if (path === "/") {
      return location.pathname === "/";
    }
    return location.pathname.startsWith(path);
  };

  const handleMenuClick = () => {
    setMenuOpen(false);
  };

  return (
    <>
      <header className="hm-header">
        <div className="hm-header-inner">
          {/* Logo */}
          <Link to="/" className="hm-logo">
            <img
              src="/images/Logo.png"
              alt="MultiFct"
              className="hm-logo-image"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hm-nav">
            <Link
              to="/"
              className={`hm-nav-link ${isActive("/") ? "active" : ""}`}
            >
              Home
            </Link>

            <Link
              to="/shop"
              className={`hm-nav-link ${isActive("/shop") ? "active" : ""}`}
            >
              Shop
            </Link>

            <Link
              to="/contact"
              className={`hm-nav-link ${isActive("/contact") ? "active" : ""}`}
            >
              Contact
            </Link>
          </nav>

          {/* Right Side */}
          <div className="hm-header-right">
            <Link to="/wishlist" className="hm-wishlist" aria-label="Wishlist">
              <svg viewBox="0 0 24 24" className="hm-heart" fill="currentColor">
                <path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8l1.1 1.1L12 21l7.8-7.5 1.1-1.1a5.5 5.5 0 0 0-.1-7.8Z" />
              </svg>
              {wishlistCount > 0 && (
                <span className="hm-wishlist-badge">{wishlistCount}</span>
              )}
            </Link>

            {/* Mobile Menu Button */}
            <button
              className="hm-menu-btn"
              onClick={() => setMenuOpen(!menuOpen)}
              aria-label="Toggle menu"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        <div className={`hm-mobile-menu ${menuOpen ? "show" : ""}`}>
          <Link
            to="/"
            className={isActive("/") ? "mobile-active" : ""}
            onClick={handleMenuClick}
          >
            Home
          </Link>

          <Link
            to="/shop"
            className={isActive("/shop") ? "mobile-active" : ""}
            onClick={handleMenuClick}
          >
            Shop
          </Link>

          <Link
            to="/contact"
            className={isActive("/contact") ? "mobile-active" : ""}
            onClick={handleMenuClick}
          >
            Contact
          </Link>
        </div>
      </header>
    </>
  );
};

export default Header;
